import styled from 'styled-components';
import { COLORS, monoValue } from '../../lib/theme';

const Group = styled.div`
  display: inline-flex;
  align-items: stretch;
  border: 1px solid ${COLORS.hairline};
`;

// Same idiom as ModeSwitch: hairline-boxed segments, no yellow -- the header
// this sits in already spends its one accent on the cam id.
const Arrow = styled.button`
  ${monoValue}
  font-size: 9px;
  padding: 2px 7px;
  cursor: pointer;
  border: 0;
  color: ${COLORS.label};
  background: transparent;

  &:hover:not(:disabled) {
    color: ${COLORS.text};
  }

  &:disabled {
    color: ${COLORS.hairline};
    cursor: default;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${COLORS.ground}, 0 0 0 4px ${COLORS.accent};
  }
`;

const Position = styled.span`
  ${monoValue}
  font-size: 9px;
  letter-spacing: 0.12em;
  padding: 2px 6px;
  border-left: 1px solid ${COLORS.hairline};
  border-right: 1px solid ${COLORS.hairline};
  color: ${(p) => (p.$live ? COLORS.text : COLORS.label)};
  white-space: nowrap;
  min-width: 5.5em;
  text-align: center;
`;

/**
 * Prev/next through one camera's stored frames. `index` is 0-based from the
 * oldest, so the readout counts up towards the newest; `live` colours it to
 * say the panel is following new arrivals rather than holding a frame.
 */
export default function FrameNav({ index, count, atOldest, atNewest, live, onOlder, onNewer }) {
  const position = count > 0 ? `${index + 1}/${count}` : '--';

  return (
    <Group aria-label="Frame history">
      <Arrow type="button" onClick={onOlder} disabled={atOldest} aria-label="Older frame" title="Older">
        {'\u25C0'}
      </Arrow>
      <Position $live={live} title={live ? 'Following the newest frame' : 'Holding an older frame'}>
        {position}
      </Position>
      <Arrow type="button" onClick={onNewer} disabled={atNewest} aria-label="Newer frame" title="Newer">
        {'\u25B6'}
      </Arrow>
    </Group>
  );
}
